export const updateTimeline = [
  {
    id: "t-1",
    time: "09:30",
    title: "早间快讯 · 隔夜热点速览",
    desc: "把昨夜到清晨的线索按时间轴串一遍，三分钟读完，通勤路上就能补完进度。",
    tag: "快讯",
    status: "published",
    heat: "8.2 万",
  },
  {
    id: "t-2",
    time: "12:00",
    title: "午间合集 · 上午爆料归档",
    desc: "把上午零散的内容合并成一份合集，遗漏的部分也会在这里补齐。",
    tag: "合集",
    status: "published",
    heat: "6.4 万",
  },
  {
    id: "t-3",
    time: "15:30",
    title: "图文更新 · 重点线梳理",
    desc: "挑出当天最有讨论度的两条线，配时间线图文，方便快速看懂来龙去脉。",
    tag: "图文",
    status: "published",
    heat: "9.1 万",
  },
  {
    id: "t-4",
    time: "19:00",
    title: "晚间主推 · 当日重头戏",
    desc: "当天更新量最大的一档，老粉基本都会蹲这个点，建议提前打开更新提醒。",
    tag: "主推",
    status: "upcoming",
    heat: "12.6 万",
  },
  {
    id: "t-5",
    time: "21:30",
    title: "加更窗口 · 网友补充线索",
    desc: "会根据评论区呼声临时加更，热门线索优先，蹲不到也别急，第二天会归档。",
    tag: "加更",
    status: "upcoming",
    heat: "5.7 万",
  },
  {
    id: "t-6",
    time: "23:00",
    title: "当日汇总 · 一键补完",
    desc: "一天所有更新打包装进一份日报，漏看的直接从这里补齐即可。",
    tag: "日报",
    status: "upcoming",
    heat: "7.3 万",
  },
];

export const reminderChannels = [
  {
    id: "c-site",
    icon: "ri-notification-3-line",
    name: "站内提醒",
    desc: "打开黑料每日时，在顶部直接看到更新提示",
  },
  {
    id: "c-browser",
    icon: "ri-computer-line",
    name: "浏览器通知",
    desc: "浏览器弹窗推送，适合一直挂着网页的蹲更党",
  },
  {
    id: "c-email",
    icon: "ri-mail-line",
    name: "邮件提醒",
    desc: "把当日更新汇总成一封邮件，漏看也能补",
  },
  {
    id: "c-digest",
    icon: "ri-calendar-check-line",
    name: "每日汇总推送",
    desc: "只在 23:00 汇总推一次，不打扰、不刷屏",
  },
];

export const reminderTimings = [
  { id: "time-now", label: "更新时立即提醒", hint: "一到时间点就推" },
  { id: "time-early", label: "更新前 10 分钟", hint: "给自己留点准备时间" },
  { id: "time-key", label: "只提醒重点场次", hint: "晚间主推 + 加更窗口" },
];

export const calendarWeek = [
  { id: "d-1", label: "周一", date: "09.07", count: 6, done: true },
  { id: "d-2", label: "周二", date: "09.08", count: 7, done: true },
  { id: "d-3", label: "周三", date: "09.09", count: 5, done: true },
  { id: "d-4", label: "周四", date: "09.10", count: 8, done: true },
  { id: "d-5", label: "周五", date: "09.11", count: 7, done: true },
  { id: "d-6", label: "周六", date: "09.12", count: 4, done: false, today: true },
  { id: "d-7", label: "周日", date: "09.13", count: 0, done: false },
];

export const flashFeed = [
  {
    id: "f-1",
    time: "15:32",
    tag: "爆料",
    title: "某综艺最新一期录制现场出现临时调整",
    summary: "现场观众反馈与预告内容不一致，目前只有零散文字线索，暂未见明确信源，先记为待核。",
    comments: 128,
    hot: true,
  },
  {
    id: "f-2",
    time: "14:58",
    tag: "回应",
    title: "相关方面就早间话题作出简短回应",
    summary: "回应内容只有一句话，没有给出更多细节，评论区普遍认为信息量不大，等待后续跟进。",
    comments: 96,
    hot: true,
  },
  {
    id: "f-3",
    time: "13:20",
    tag: "热榜",
    title: "上午的合集内容冲上了当天讨论前列",
    summary: "主要由网友自发整理的时间线带动，讨论集中在细节比对，属实锤还是脑补仍在争执中。",
    comments: 214,
    hot: false,
  },
  {
    id: "f-4",
    time: "11:47",
    tag: "路透",
    title: "有网友在社交平台晒出疑似现场片段",
    summary: "片段时长较短且画质一般，暂时无法确认时间地点，已放入待核列表，不建议当作结论。",
    comments: 73,
    hot: false,
  },
  {
    id: "f-5",
    time: "10:15",
    tag: "快讯",
    title: "早间速览提到的线索有了新的一条补充",
    summary: "补充内容来自评论区高赞留言，与原有信息方向一致，可信度略有提升但仍需观望。",
    comments: 51,
    hot: false,
  },
  {
    id: "f-6",
    time: "09:31",
    tag: "爆料",
    title: "隔夜多条线索集中出现在同一时间段",
    summary: "集中在凌晨两小时内出现，时间点过于密集，老粉提醒理性看待，不排除是同一批内容的搬运。",
    comments: 87,
    hot: false,
  },
];

export const feedTabs = ["全部", "爆料", "回应", "热榜", "路透", "快讯"];

export const initialComments = [
  {
    id: "cm-1",
    user: "蹲到天亮",
    badge: "连续打卡 42 天",
    text: "晚间的那个点真的不能错过，今天中午的合集我漏了，晚上主推里直接给我补上了，省心。",
    time: "3 分钟前",
    likes: 128,
    liked: false,
  },
  {
    id: "cm-2",
    user: "理性吃瓜第1条",
    badge: "老粉",
    text: "提醒一下新来的，看到没有明确信源的就先记着，别急着下结论，追更日历上打卡慢慢看更稳。",
    time: "12 分钟前",
    likes: 96,
    liked: false,
  },
  {
    id: "cm-3",
    user: "加班也要蹲",
    badge: "连续打卡 18 天",
    text: "我把提醒设成只推重点场次了，不然一整天消息太多了，这个设置真的很懂打工人。",
    time: "28 分钟前",
    likes: 61,
    liked: false,
  },
  {
    id: "cm-4",
    user: "周末补课党",
    badge: "新粉",
    text: "请教一下，几点更新最容易蹲到完整的？我每次都只能看到零散的，想系统补一遍。",
    time: "1 小时前",
    likes: 34,
    liked: false,
  },
];

export const faqList = [
  {
    id: "q-1",
    q: "黑料每日几点更新？",
    a: "常规更新节点集中在 09:30、12:00、15:30 三个时段，重点是 19:00 的晚间主推，之后 21:30 有加更窗口，23:00 出当日汇总。想蹲完整的更新，建议直接盯晚间主推和当日汇总两个点。",
  },
  {
    id: "q-2",
    q: "更新提醒怎么开？错过更新怎么办？",
    a: "在「更新提醒设置」里挑一个推送渠道，再选提醒时机即可。如果错过，不必回翻零散内容，直接看 23:00 的当日汇总就能一键补完。",
  },
  {
    id: "q-3",
    q: "追更日历和打卡有什么用？",
    a: "追更日历把一周的更新量标出来，让你提前规划蹲守节奏；打卡则用来记录自己的追更进度，连续打卡天数会显示在评论区，属于老粉之间的小仪式感。",
  },
  {
    id: "q-4",
    q: "订阅要花钱吗？会不会推很多消息？",
    a: "订阅本身免费。推送频率取决于你选的时机：选「只提醒重点场次」时，一天只会收到晚间主推和加更窗口两条，其余内容需要自己回来查看。",
  },
];

export const hotKeywords = [
  "今日更新节点",
  "晚间主推",
  "加更窗口",
  "当日汇总",
  "追更打卡",
  "提醒时机",
];

export const siteStats = [
  { id: "s-1", value: "6", unit: "个", label: "每日固定更新节点" },
  { id: "s-2", value: "23:00", unit: "", label: "当日汇总归档时间" },
  { id: "s-3", value: "4.8 万", unit: "人", label: "正在追更打卡" },
  { id: "s-4", value: "42", unit: "天", label: "老粉最长连续打卡" },
];